import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Vérifier si une position de scroll est sauvegardée pour cette page
    const pageKey = pathname.substring(1); // Enlever le "/"
    const savedScrollY = sessionStorage.getItem(`scroll-${pageKey}`);

    if (savedScrollY) {
      // Restaurer la position sauvegardée
      window.scrollTo(0, parseInt(savedScrollY, 10));
    } else {
      // Sinon, scroller en haut comme d'habitude
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
